import React from "react";
import Modal from "react-modal";
import { useNavigate } from "react-router-dom";
import {
  ADMIN_SUBSCRIPTION_MODAL_DISMISSED_KEY,
  SETTINGS_SUBSCRIPTION_PATH,
} from "../Utils/subscriptionAccess";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    border: "none",
    background: "transparent",
    padding: "0",
    maxWidth: "min(440px, 92vw)",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 1000,
  },
};

export default function AdminSubscriptionRequiredModal({ isOpen, onClose }) {
  const navigate = useNavigate();

  const goToSubscription = () => {
    try {
      sessionStorage.setItem(ADMIN_SUBSCRIPTION_MODAL_DISMISSED_KEY, "1");
    } catch (_) {
      /* ignore */
    }
    navigate(SETTINGS_SUBSCRIPTION_PATH);
    onClose?.();
  };

  const dismissForSession = () => {
    try {
      sessionStorage.setItem(ADMIN_SUBSCRIPTION_MODAL_DISMISSED_KEY, "1");
    } catch (_) {
      /* ignore */
    }
    onClose?.();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={dismissForSession}
      style={customStyles}
      contentLabel="Subscription required"
      ariaHideApp={false}
    >
      <div
        className="modal-content"
        style={{ borderRadius: "12px", overflow: "hidden", boxShadow: "0 8px 32px rgba(0,0,0,0.12)" }}
      >
        <div className="modal-header" style={{ borderBottom: "1px solid #eee" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
            <span style={{ fontWeight: 700, fontSize: "1.1rem" }}>Admin account</span>
            <button type="button" className="close" onClick={dismissForSession} aria-label="Close">
              <img src={window.getPublicUrl("/assets/images/close.svg")} alt="" />
            </button>
          </div>
        </div>
        <div className="modal-body" style={{ padding: "1.25rem 1.5rem" }}>
          <p style={{ margin: "0 0 1rem", color: "#374151", lineHeight: 1.55 }}>
            You are registered as an <strong>admin</strong> for this family. To use Dashboard, Family Tree,
            Events, Messages, and Reports, please purchase <strong>any one</strong> subscription plan.
          </p>
          <p style={{ margin: "0 0 1.25rem", fontSize: "0.875rem", color: "#6b7280" }}>
            Open <strong>Settings → Subscription</strong> to choose a plan and complete payment.
          </p>
          <div style={{ display: "flex", flexDirection: "column", gap: "0.65rem" }}>
            <button
              type="button"
              className="signup-payment-submit-button"
              style={{ width: "100%" }}
              onClick={goToSubscription}
            >
              Go to subscription plans
            </button>
            <button
              type="button"
              className="signup-plans-skip-btn"
              style={{ width: "100%", background: "#e5e7eb", color: "#374151" }}
              onClick={dismissForSession}
            >
              I’ll do this later
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
